/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'us.edriffles.radlib.private.respondFollow'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  requester: /*#__PURE__*/ l.string({ format: 'did' }),
  approve: /*#__PURE__*/ l.boolean(),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  requester: /*#__PURE__*/ l.string({ format: 'did' }),
  state: /*#__PURE__*/ l.string<{
    knownValues: [
      'none',
      'requested',
      'approved',
      'denied',
      'revoked',
      'blocked',
    ]
  }>(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Approve or deny a protected-account access request. Only the protected account may respond. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
